import React, {useEffect, useState} from 'react';
import {ResponseTest} from "./in-the-form/response-test/ResponseTest";
import {ReactComponent as CorrectIcon} from '../../../../../assets/main/test/response/text-questions/correct.svg';
import {InTheForm} from "./in-the-form/InTheForm";
import {
    ResponseOptionsTab
} from "components/pages/test/test-inner-answer/response-options/response-options-tab/ResponseOptionsTab";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";
import {useAppDispatch} from "common/hook";



export const ResponseOptions = () => {
    const [activeTab, setActiveTab] = useState('inForm');


    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <div>
            <div className="test-heading">
                <div className="test-title">
                    <p className="h3">Вопросы</p>
                    <span className="status-item bordered">
                        Тест пройден
                            <span className="icon">
                                <CorrectIcon/>
                            </span>
                    </span>
                </div>
                <ResponseOptionsTab handleTabClick={handleTabClick} activeTab={activeTab}/>
            </div>

            <ResponseTest/>

            <InTheForm activeTab={activeTab}/>

        </div>
    );
};
